// extracted by mini-css-extract-plugin
export default {"video":"Big_video__IaM29","simulation":"Big_simulation__6BzpG","name":"Big_name__ZQ5tc","tt":"Big_tt__5xfBN","text":"Big_text__epaA3","bh1":"Big_bh1__J5pf9"};